import React, { useCallback, useContext, useState } from 'react'
import { Point } from 'assets'
import { Img } from 'styles/GlobalStyle'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { CheckPermissionStyles, FabButtonStyles } from './Style'
import { ReactComponent as RefreshPermissionIcon } from 'assets/icons/RefreshPermission.svg';
import { AnimatePresence } from "motion/react"
import { IconButton, SvgIcon } from '@mui/material'
import { microphon_off_male, microphon_off_female } from 'introductions'
import ReactPlayer from 'react-player'
import * as motion from "motion/react-client"
import TooltipMessage from './Tooltip'
import tooltips from './utils/tooltips'

const CheckPermissions = () => {
    const { setMicDisabled, isMaleGender, isHighGrade, } = useContext(PerformAssessmentContext)
    const [cartoonSpeaking, setCartoonSpeaking] = useState(true)

    const checkPermissions = useCallback(() => {
        setCartoonSpeaking(false)
        navigator.getUserMedia = (navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia);
        navigator.getUserMedia({ audio: true },
            () => {
                setMicDisabled(false)
            },
            () => {
                setCartoonSpeaking(true)
            }
        );
    }, [])

    return (
        <CheckPermissionStyles>
            <AnimatePresence mode="wait">
                <div className='wrap-cartoon-and-button'>
                    {isHighGrade ?
                        <TooltipMessage tooltip={isMaleGender ? tooltips.no_mic_m : tooltips.no_mic_f} /> :
                        <motion.div
                            exit={{ opacity: 0 }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.7 }}
                            className='cartoon-img'
                            key="cartoon-img"
                        >
                            <div className='check-permissions-img'>
                                <Img src={cartoonSpeaking ? Point : Point} />
                            </div>
                        </motion.div>
                    }
                    <div className='refresh-check-permissions-img'>
                        <motion.div
                            exit={{ opacity: 0 }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.7 }}
                            className='mic-img'
                            key="mic-img"
                        >
                            <div className='wrap-fab-button'>
                                <FabButtonStyles onClick={checkPermissions}>
                                    <IconButton onClick={() => { }}>
                                        <SvgIcon fontSize='small' component={RefreshPermissionIcon} inheritViewBox />
                                    </IconButton>
                                </FabButtonStyles>
                            </div>
                        </motion.div>
                    </div>
                </div>
                <ReactPlayer
                    playing={
                        // !isHighGrade && 
                        cartoonSpeaking}
                    url={isMaleGender ? microphon_off_male : microphon_off_female}
                    width='0px' height='0px'
                    onEnded={() => setCartoonSpeaking(false)}
                />
            </AnimatePresence>
        </CheckPermissionStyles >
    )
}

export default CheckPermissions